// size of screen
export const maxTabletWidth = 1200;
export const maxMobileWidth = 767;

export const spaceRatio = 5;